import { t } from '../../shared/i18n.js';
import * as THREE from 'three';

const REACH = 10; // metres from the marker at which a stop counts

function beacon(color) {
  const g = new THREE.CylinderGeometry(2.2, 2.2, 60, 20, 1, true);
  g.translate(0, 30, 0);
  const m = new THREE.Mesh(g, new THREE.MeshBasicMaterial({ color, transparent: true, opacity: 0.32, side: THREE.DoubleSide, depthWrite: false, fog: false }));
  m.visible = false;
  return m;
}

// Taxi and bike work: find a passenger, pick them up, take them where they
// are going, get paid. The server chooses the passenger and pays the fare.
export class Jobs {
  constructor(scene, map, net, hud) {
    this.map = map;
    this.net = net;
    this.hud = hud;
    this.job = null;
    this.money = null;
    this.from = beacon(0xf2b705);
    this.to = beacon(0x46a758);
    scene.add(this.from, this.to);
    this.sent = 0;

    net.on('job', (m) => this.setJob(m.job));
    net.on('paid', (m) => {
      this.job = null;
      this.money = m.money;
      this.showMarks();
      const tip = m.tip ? ` and ${m.tip.toLocaleString('en-US')} on top` : '';
      hud.toast(`${m.name}: "${m.line || 'Thank you, driver.'}" Paid ${m.amount.toLocaleString('en-US')} FCFA${tip}.`, 5500);
      if (this.onPaid) this.onPaid(m);
    });
    net.on('money', (m) => {
      this.money = m.money;
    });
    // what the player's stalls and houses brought in since they were last told
    net.on('earned', (m) => {
      this.money = m.money;
      hud.toast(`Your stalls and houses brought in ${m.amount.toLocaleString('en-US')} FCFA`, 6000);
    });
  }

  setJob(job) {
    const fresh = !this.job || this.job.id !== job.id;
    this.job = job;
    this.showMarks();
    if (fresh) this.hud.toast(`${job.name} wants to go to ${job.to}. Fare ${job.fare.toLocaleString('en-US')} FCFA.`, 5000);
    else if (job.stage === 'ride') {
      this.hud.toast(`${job.name} is in. Drive to ${job.to}.`, 4000);
      if (this.onPickup) this.onPickup(job);
    }
  }

  showMarks() {
    const j = this.job;
    const h = this.map.heightmap;
    this.from.visible = !!j && j.stage === 'pickup';
    this.to.visible = !!j && j.stage === 'ride';
    if (!j) return;
    this.from.position.set(j.fx, h.heightAt(j.fx, j.fz), j.fz);
    this.to.position.set(j.tx, h.heightAt(j.tx, j.tz), j.tz);
  }

  // Points for the corner map: where to go next.
  marks() {
    const j = this.job;
    if (!j) return [];
    return j.stage === 'pickup' ? [{ x: j.fx, z: j.fz, color: '#f2b705' }] : [{ x: j.tx, z: j.tz, color: '#46a758' }];
  }

  // The townsperson riding with the player, so they are not also drawn on the street.
  passenger() {
    return this.job && this.job.stage === 'ride' ? this.job.person : -1;
  }

  // J asks for a passenger, or gives up the current one.
  toggle(vehicle, clock) {
    if (!this.net.online) {
      this.hud.toast('Work needs the server. It is not connected.');
      return;
    }
    if (this.job) {
      this.net.send({ t: 'quit' });
      this.job = null;
      this.showMarks();
      this.hud.toast('You gave up the ride');
      return;
    }
    this.net.send({ t: 'ride', veh: vehicle ? vehicle.def.id : 0, hour: clock.hour, weekday: clock.weekday });
  }

  // Call every frame while driving. Stopping at a marker picks up or drops off.
  update(vehicle, t) {
    const j = this.job;
    if (!j || !vehicle || Math.abs(vehicle.speed) > 2.5 || t - this.sent < 1200) return;
    if (j.stage === 'pickup' && Math.hypot(vehicle.x - j.fx, vehicle.z - j.fz) < REACH) {
      this.sent = t;
      this.net.send({ t: 'pickup' });
    } else if (j.stage === 'ride' && Math.hypot(vehicle.x - j.tx, vehicle.z - j.tz) < REACH + 4) {
      this.sent = t;
      this.net.send({ t: 'dropoff' });
    }
  }
}
